import { create } from 'zustand';
import type { FlowStep } from 'components/OrderFlowTimeline';

interface IConfirm {
  title: string;
  subtitle?: string;
  flowStep?: FlowStep;
  flowDirection?: 'forward' | 'backward';
  message: string;
  variant?: 'error' | 'success' | 'warning';
  onSubmit: (x: boolean) => Promise<any> | void;
}

export const useConfirmDialogStore = create<IConfirm & { close: () => void; open: boolean }>((set) => ({
  title: '',
  subtitle: undefined,
  flowStep: undefined,
  flowDirection: undefined,
  message: '',
  open: false,
  variant: 'error',
  onSubmit: (open: boolean) => set({ open }),
  close: () => set({ open: false })
}));

export const confirmDialog = ({ title, subtitle, flowStep, flowDirection, message, variant = 'error', onSubmit }: IConfirm) => {
  useConfirmDialogStore.setState({ title, subtitle, flowStep, flowDirection, open: true, variant, message, onSubmit });
};
